import {Pipe, PipeTransform} from '@angular/core';
import {ProductionSchedule} from '@domain/production-schedule/production-schedule';
import {ProductionSchedulePath} from '@domain/production-schedule/production-schedule-path';
import {ProductionSchedulePathsOfColoredYarnSet} from '@domain/production-schedule/production-schedule-paths-of-colored-yarn-set';
import {isEqual, reduce, size, slice} from 'lodash-es';

@Pipe({
  name: 'getProductionScheduleColoredYarnSetPaths'
})
export class GetProductionScheduleColoredYarnSetPathsPipe implements PipeTransform {
  public transform(
    productionScheduleColoredYarnSet: ProductionSchedulePathsOfColoredYarnSet,
    productionScheduleColoredYarnSetIndex: number,
    productionSchedule: ProductionSchedule
  ): ProductionSchedulePath[] {
    let result: ProductionSchedulePath[] = [];

    if (productionScheduleColoredYarnSet.hasProductionSchedulePaths()) {
      result = productionScheduleColoredYarnSet.productionSchedulePaths;
    } else {
      const pathNumber = this.getPathNumber(productionSchedule, productionScheduleColoredYarnSetIndex);

      result = [new ProductionSchedulePath(`Path ${pathNumber}`, pathNumber, 0, 0, [], 0, 0, 0)];
    }
    return result;
  }

  private getPathNumber(productionSchedule: ProductionSchedule, productionScheduleColoredYarnSetIndex: number): number {
    const productionScheduleColoredYarnSetsToIterate: ProductionSchedulePathsOfColoredYarnSet[] = slice(
      productionSchedule.productionSchedulePathsOfColoredYarnSets,
      0,
      productionScheduleColoredYarnSetIndex + 1
    );

    return reduce(
      productionScheduleColoredYarnSetsToIterate,
      (pathNumber: number, productionScheduleColoredYarnSet: ProductionSchedulePathsOfColoredYarnSet, index: number) => {
        if (!isEqual(index, productionScheduleColoredYarnSetIndex)) {
          if (productionScheduleColoredYarnSet.hasProductionSchedulePaths()) {
            pathNumber += size(productionScheduleColoredYarnSet.productionSchedulePaths);
          } else {
            pathNumber++;
          }
        }
        return pathNumber;
      },
      1
    );
  }
}
